import React from 'react';
import { Alarm } from '@saleshandy/icons';

const GrayColorAlarm = () => (
  <Alarm width={16} height={16} className="gray-txt-15" />
);

export default GrayColorAlarm;
